export default () => {
	if (
		localStorage.getItem("isEuropean") == null
		|| localStorage.getItem("isEuropean") == 1
		|| window.location.hash !== "#embed"
	) {
		window.onload = () => {
			setTimeout(() => {
				if (localStorage.getItem("isEuropean") == 1) {
					window.cookieconsent.initialise({
						palette: {
							popup: { background: "#074ca4" },
							button: { background: "#cdb028" },
						},
						theme: "edgeless",
						content: {
							message: translate.cookie_law_message,
							dismiss: translate.cookie_law_dismiss,
							link: translate.cookie_law_link,
							href: links.cookielaw_policy,
						},
					});
				} else {
					$.get("//geo.juegosjuegos.com/", (data) => {
						localStorage.setItem("isEuropean", data);
						if (data != "0") {
							window.cookieconsent.initialise({
								palette: {
									popup: { background: "#074ca4" },
									button: { background: "#cdb028" },
								},
								theme: "edgeless",
								content: {
									message: translate.cookie_law_message,
									dismiss: translate.cookie_law_dismiss,
									link: translate.cookie_law_link,
									href: links.cookielaw_policy,
								},
							});
						}
					});
				}
			}, 5000);
		};
	}
};
